import { Button } from "@mui/material";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useDisconnectMicrosoftOauthMutation } from "../../integrationsApiSlice";

const Microsoft = (props) => (
	<svg
		viewBox="0 0 256 256"
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		preserveAspectRatio="xMidYMid"
		{...props}
	>
		<path fill="#F1511B" d="M121.666 121.666H0V0h121.666z" />
		<path fill="#80CC28" d="M256 121.666H134.335V0H256z" />
		<path fill="#00ADEF" d="M121.663 256.002H0V134.336h121.663z" />
		<path fill="#FBBC09" d="M256 256.002H134.335V134.336H256z" />
	</svg>
);

export const DisconnectMicrosoftOauth = () => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();

	const [disconnectMicrosoftOauth, { isLoading }] =
		useDisconnectMicrosoftOauthMutation();

	const handleDisconnect = async () => {
		await disconnectMicrosoftOauth()
			.unwrap()
			.then((_payload) => {
				enqueueSnackbar(t("ms_oauth_disconnected"), {
					variant: "success",
				});
			})
			.catch((error) => {
				if (error?.data?.errors) {
					const errors = error.data.errors;
					Object.entries(errors).forEach(([_key, message]) => {
						enqueueSnackbar(message[0], {
							variant: "error",
							preventDuplicate: true,
						});
					});
				} else {
					enqueueSnackbar(error?.data?.message || t("default_error"), {
						variant: "error",
						preventDuplicate: true,
					});
				}
			});
	};

	return (
		<Button
			variant="contained"
			loading={isLoading}
			disabled={isLoading}
			onClick={handleDisconnect}
			color="error"
			sx={{
				position: "relative",
				overflow: "hidden",
				display: "flex",
				alignItems: "center",
				gap: "8px",
			}}
		>
			{t("unlink_account")}
			<Microsoft />
		</Button>
	);
};
